import { EMPTY_OBJECT } from '../../../../constants/common'
import { ComponentLabel } from '../ComponentLabel'

export function component(
  name,
  props = EMPTY_OBJECT,
  labelProps = EMPTY_OBJECT
) {
  return <ComponentLabel {...labelProps} name={name} props={props} />
}
